// Centralizamos contactos y configuración para que sea fácil de actualizar.
// Reemplaza WHATSAPP con tu número real (formato internacional sin + ni espacios).
export const CONTACT = {
  name: 'Dante Milano',
  role: 'Desarrollador Full Stack',
  location: 'Luján, Buenos Aires, Argentina',
  email: 'milano.dante.it@gmail.com',
  linkedin: 'https://www.linkedin.com/in/dante-milano/',
  github: 'https://github.com/', // TODO: completar con tu URL real
  portfolio: 'https://www.dantemilano.xyz/',
  cvUrl: 'https://cv.dantemilano.xyz/',
  // IMPORTANTE: poner tu número real. Formato: código país + área + número, sin espacios.
  // Ej: 5492323219760 (Argentina + Luján + número)
  whatsapp: '5492323000000',
  whatsappMessage: 'Hola Dante! Vi tu CV y me gustaría consultarte sobre un proyecto.',
};
